export function drawFan(data, config = {}) {

}
